module.exports = __webpack_public_path__ + "img/IMG-20220207-WA0031.f41f8d9e.jpg";